import ReactMarkdown from "react-markdown";

interface MarkdownContentProps {
  content: string;
}

export const MarkdownContent = ({ content }: MarkdownContentProps) => {
  return (
    <div className="markdown-content">
      <ReactMarkdown
        components={{
          h2: ({ children }) => (
            <h2 className="text-2xl md:text-3xl font-bold mt-12 mb-6 pb-3 border-b border-border text-foreground">
              {children}
            </h2>
          ),
          h3: ({ children }) => (
            <h3 className="text-xl md:text-2xl font-bold mt-8 mb-4 text-foreground">
              {children}
            </h3>
          ),
          p: ({ children }) => (
            <p className="text-base md:text-lg leading-[1.75] mb-6 text-foreground">
              {children}
            </p>
          ),
          ul: ({ children }) => (
            <ul className="my-6 space-y-3 list-disc pl-6">
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol className="my-6 space-y-3 list-decimal pl-6">
              {children}
            </ol>
          ),
          li: ({ children }) => (
            <li className="text-base md:text-lg leading-relaxed text-foreground pl-2">
              {children}
            </li>
          ),
          strong: ({ children }) => (
            <strong className="font-semibold text-foreground">
              {children}
            </strong>
          ),
          em: ({ children }) => (
            <em className="italic">
              {children}
            </em>
          ),
          a: ({ href, children }) => (
            <a 
              href={href} 
              className="text-primary font-medium underline-offset-4 hover:underline"
              target={href?.startsWith('http') ? '_blank' : undefined}
              rel={href?.startsWith('http') ? 'noopener noreferrer' : undefined}
            >
              {children}
            </a>
          ),
          blockquote: ({ children }) => (
            <blockquote className="border-l-4 border-primary pl-6 py-2 my-6 italic text-muted-foreground">
              {children}
            </blockquote>
          ),
          code: ({ children }) => (
            <code className="bg-muted text-primary px-1.5 py-0.5 rounded text-sm font-mono">
              {children}
            </code>
          ),
          hr: () => (
            <hr className="my-12 border-border" />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
